import API from '../../api/api';
import * as actionTypes from '../actionTypes';
import { message } from 'antd';

function documentiTrasparenza(apiPath) {
  return (dispatch) => {
    API.getAxios(apiPath).get(`/documentiTrasparenza`)
      .then(response => {
        dispatch({ type: actionTypes.SALVA_DOCUMENTI_TRASPARENZA, payload: response.data});
      })
      .catch(errore => { 
        message.error(`Errore ${errore.response.data.errorCode}: ${errore.response.data.errorMessage}`,15);
      })
  };
}

export default documentiTrasparenza;